export default {
  ui: {
    inputRepositoryURL: 'リポジトリURL を入力'
  }
}
